import { Application } from "@hotwired/stimulus";
import HeaderController from "./Controllers/HeaderController";
import LightboxController from "./Controllers/LightboxController";
import TabsController from "./Controllers/TabsController";

const application = Application.start();

application.register("header", HeaderController);
application.register("lightbox", LightboxController);
application.register("tabs", TabsController);
